//20251108: xt add the email report for preselected emails in email Modal
//
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { hideModal } from '../../actions/modal';
import Globals from '../../utils/globals'; // import like messages.js does
import { postInternalMessage } from "../../actions/internalMessages"; // for the email report feature
import './IncidentEmailModal.css';  // its own css space

const PREVIEW = false; // keep true while we shape the UI
const PREVIEW_RECIPIENTS = [
    { name: 'Mark Brown', email: 'brassstar@me.com', dept: 'Security' },
    { name: 'Bill Smith', email: 'cs@citynewscasts.com', dept: 'Operations' },
    { name: 'Sue Jones', email: 'dev@brassstar.com', dept: 'Maintenance' },
];

const FROM_LABEL = 'Transit Watch Dispatch Console';

// THIS IS SAMPLE POSTMAN TO TEST THE /RECIPIENTS ENDPOINT (need token set of course)
//https://bsgbackend-staging.herokuapp.com/emails/recipients?agencyId=6473b3f5c0886f647d56ee20
// THIS IS SAMPE OF THE MODAL PROPS FOR REFERENCE 
// {
//   "incident": { /* the full incident object you passed */ },
//   "agencyId": "6473b3f5c0886f647d56ee20",
//   "reportSchemaId": "59473aeb0a1020001abc1001",
//   "agencyName": "People Mover Transit Watch"
// }
export default function IncidentEmailModal() {
    const dispatch = useDispatch();
    const { getAccessTokenSilently } = useAuth0();

    const visible = useSelector((s) => s.modal?.visible || false);
    const modalProps = useSelector((s) => s.modal?.modalProps || {});

    // Grab current dispatcher profile for email log entries
    const profile = useSelector((state) => state.profile || {});

    //const incident = modalProps?.incident;
    //const agencyId = modalProps;
    const { incident, agencyId, reportSchemaId, agencyName: agencyNameFromProps } = modalProps;
    //console.log('[EmailModal] modalProps =', modalProps); // to check the json

    const agencyState = useSelector((s) => s.agency);  // ✅ fallback source if ever needed
    const [recipients, setRecipients] = useState([]);
    //const [fromAddress, setFromAddress] = useState('');
    const [fromAddress] = useState(FROM_LABEL); // NOTE THIS IS HARD CODED
    const [subject, setSubject] = useState('');
    const [selected, setSelected] = useState([]);
    const [adHoc, setAdHoc] = useState('');
    const [note, setNote] = useState('');
    const [sending, setSending] = useState(false);
    const [sentOk, setSentOk] = useState(false);
    const [error, setError] = useState(null);


    // Make a nice option label for combo box like: "Mark Brown <bill@x.com> — Operations"
    const labelFor = (r) =>
        r?.name
            ? `${r.name} <${r.email}>${r.dept ? ` — ${r.dept}` : ''}`
            : r?.email || '';

    // Options that are NOT already selected
    const available = recipients.filter((r) => !selected.includes(r.email));

    // resolve agency id to be safe..but chat doesnt do this only chatgpt put it in here
    const resolvedAgencyId =
        agencyId ||
        agencyState?.agencyId ||
        agencyState?.details?._id ||
        '';
    //
    // ✅ Resolve agencyName reliably:
    const agencyName =              // we are making sure it exists
        agencyNameFromProps ||                             // preferred: passed in from IncidentAction
        agencyState?.details?.name?.en_US ||                 // fallback from Redux
        agencyState?.details?.display_name ||
        agencyState?.details?.name ||
        'Transit Watch';

    const defaultSubject =
        `[FROM DISPATCH:]${agencyName} Report: ` +
        `${incident?.display_title || ''}: ${incident?.title || ''}`;

    useEffect(() => {
        if (!visible || !incident?._id) return;
        setSubject(defaultSubject);
        setSentOk(false);
        setError(null);

        if (PREVIEW) {
            setRecipients(PREVIEW_RECIPIENTS);
            //setFromAddress(PREVIEW_FROM);
            return;
        }

        (async () => {
            try {
                const token = await getAccessTokenSilently();

                const url = `${Globals.apiEndpoint}/emails/recipients?agencyId=${encodeURIComponent(resolvedAgencyId)}`;
                console.log('[EmailModal] GET', url); // debug

                const resp = await fetch(url, {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    mode: 'cors',        // safe default; Chat actions work without "include"
                });

                if (!resp.ok) {
                    const t = await resp.text().catch(() => '');
                    throw new Error(t || `HTTP ${resp.status}`);
                }

                const ct = resp.headers.get('content-type') || '';
                if (!ct.includes('application/json')) {
                    const t = await resp.text().catch(() => '');
                    // This is the exact pink-bar case: HTML came back
                    throw new Error(
                        t?.startsWith('<!doctype') ? 'Server returned HTML (check API base URL / auth / HTTPS redirect)' : 'Unexpected response type'
                    );
                }

                const recJson = await resp.json();
                setRecipients(Array.isArray(recJson?.items) ? recJson.items : []);
            } catch (e) {
                console.error('[EmailModal] recipients error:', e);
                setError(e.message || 'Failed to load recipients');
            }
        })();


    }, [visible, incident?._id]);


    if (!visible || !incident?._id) return null;

    const hide = () => dispatch(hideModal());

    const addAdHoc = () => {
        const e = (adHoc || '').trim();
        if (!e) return;
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) return alert('Invalid email');
        setSelected((curr) => Array.from(new Set([...(curr || []), e])));
        setAdHoc('');
    };

    const onSend = async () => {
        if (selected.length === 0) return alert('Pick at least one recipient');
        if (PREVIEW) {
            setSending(true);
            setTimeout(() => { setSending(false); setSentOk(true); }, 350);
            return;
        }
        try {
            setSending(true);
            const token = await getAccessTokenSilently();

            const url = `${Globals.apiEndpoint}/emails/${encodeURIComponent(incident._id)}/email-manual`;
            console.log('[EmailModal] POST', url); // debug

            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                mode: 'cors',
                body: JSON.stringify({
                    to: selected,
                    subject: subject || defaultSubject,
                    note,
                }),
            });

            if (!res.ok) {
                const t = await res.text().catch(() => '');
                throw new Error(t || `HTTP ${res.status}`);
            }
            // added for email report button feature
            const message = {
                type: "log",
                display_name: profile.user_metadata?.name || profile.name || "Dispatcher",
                message:
                    `Report Emailed\n\n` +
                    `To: ${selected.join(", ")}\n` +
                    `Subject: ${subject || defaultSubject}`,
                sender_id: profile.sub,
                sent: Date.now(),
                emailed: true,
            };

            // now write the email report send info to the log notes
            await dispatch(
                postInternalMessage(
                    incident._id,
                    resolvedAgencyId,
                    reportSchemaId,
                    message,
                    token
                )
            );
            setSentOk(true);
            setSelected([]);
            setAdHoc('');
        } catch (e) {
            console.error('[EmailModal] send error:', e);
            setError(e.message || 'Send failed');
        } finally {
            setSending(false);
        }
    };


    // simple helpers for the snapshot
    const photos = Array.isArray(incident?.photos) ? incident.photos : [];
    const coord = incident?.coordinate || incident?.coordinates || '';

    // THESE ARE HELPERS FOR EMAIL TO FUNCTIONALITY
    // Build a user-friendly label for each option
    const labelOf = (r) => {
        const dept = r.dept || r.listLabel;
        return r.name ? `${r.name} <${r.email}>${dept ? ` — ${dept}` : ''}` : r.email;
    };

    // Only show items that aren't already selected
    const availableRecipients = recipients.filter(r => !selected.includes(r.email));

    // Validate ad-hoc email
    const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());

    // Add from combo: if adHoc matches a known option by email, add that; else if it looks like an email, add it as ad-hoc
    const addFromCombo = () => {
        const raw = (adHoc || '').trim();
        if (!raw) return;

        // exact email match against available options
        const match = availableRecipients.find(r => r.email.toLowerCase() === raw.toLowerCase());

        if (match) {
            setSelected((curr) => Array.from(new Set([...(curr || []), match.email])));
            setAdHoc('');
            return;
        }

        // otherwise accept a valid email typed by the user
        if (isEmail(raw)) {
            setSelected((curr) => Array.from(new Set([...(curr || []), raw])));
            setAdHoc('');
            return;
        }

        alert('Pick an item from the list or enter a valid email address.');
    };

    // Remove a selected email
    const removeSelected = (email) => {
        setSelected((curr) => (curr || []).filter(e => e !== email));
    };
    /// END OF EMAIL FUNCTIONING


    return (
        <div>
            {/* Backdrop (dim background) */}
            <div className="email-modal-backdrop" />

            {/* Centered modal */}
            <div className="email-modal-root" role="dialog" aria-modal="true" aria-label="Email Report Modal">
                <div className="email-modal-dialog">
                    <div className="email-modal-content">
                        <div className="email-modal-header">
                            <h5 className="email-modal-title">
                                <i className="material-icons">email</i>
                                <span>
                                    Email Report — {incident?.display_title} — {incident?.title}
                                </span>
                            </h5>
                            <button type="button" className="email-modal-close" onClick={hide}>Close X</button>
                        </div>

                        <div className="email-modal-body">
                            {/* From */}
                            <div className="email-field">
                                <label>From</label>
                                <input className="email-input" value={fromAddress || 'Configured SES identity'} readOnly />
                            </div>

                            {/* Subject */}
                            <div className="email-field">
                                <label>Subject</label>
                                <input className="email-input" value={subject} onChange={(e) => setSubject(e.target.value)} />
                            </div>

                            {/* To */}
                            <div className="email-field">
                                <label>
                                    Add & Select Recipients <span className="email-required">* Required</span>
                                </label>

                                {/* Selected list (chips) */}
                                {selected.length > 0 && (
                                    <div className="email-selected-list">
                                        {selected.map((e) => (
                                            <span key={e} className="email-chip">
                                                {e}
                                                <button
                                                    type="button"
                                                    className="email-chip-x"
                                                    onClick={() => removeSelected(e)}
                                                    aria-label={`Remove ${e}`}
                                                    title="Remove"
                                                >
                                                    ×
                                                </button>
                                            </span>
                                        ))}
                                    </div>
                                )}

                                {/* Combo box: input + datalist + Add button */}
                                <div className="email-row">
                                    {/* HTML5 combo via datalist for type-ahead */}
                                    <input
                                        list="email-recips"
                                        className="email-input"
                                        placeholder="Start typing a name or email…"
                                        value={adHoc}
                                        onChange={(e) => setAdHoc(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') { e.preventDefault(); addFromCombo(); }
                                        }}
                                    />
                                    <datalist id="email-recips">
                                        {availableRecipients.map((r) => (
                                            <option key={r.email} value={r.email} label={labelOf(r)} />
                                        ))}
                                    </datalist>

                                    <button
                                        type="button"
                                        className={`email-btn-secondary ${adHoc?.trim() || selected.length > 0 ? 'active' : ''
                                            }`}
                                        onClick={addFromCombo}
                                        disabled={!adHoc?.trim() && selected.length === 0}
                                    >
                                        Add
                                    </button>
                                </div>

                                {/* Helper text */}
                                <div className="email-help">
                                    Choose from the list or type an email, then click <strong>Add</strong>.
                                </div>
                            </div>



                            {/* Optional note */}
                            <div className="email-field">
                                <label>Optional note (prepended to body)</label>
                                <textarea
                                    className="email-textarea"
                                    rows={5}
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                />
                            </div>

                            {error && <div className="email-alert error">{String(error)}</div>}
                            {sentOk && <div className="email-alert success">Email sent successfully. You may send another or close this window.</div>}

                            <div className="email-footer">
                                <button className="email-btn" onClick={hide}>Cancel</button>
                                <button
                                    className="email-btn primary"
                                    disabled={sending || selected.length === 0}
                                    onClick={onSend}
                                >
                                    {sending ? 'Sending…' : 'Send'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}
